import React, { useEffect, useState, useContext, useCallback } from "react";
import { RedirectUrlValue } from '../../context/RedirectUrlValue.js';
import { LanguageValue } from '../../context/LanguageValue';
import { getClientByClient, getOnLanguage } from '../api';
import Loading from '../Loading';

export default function() {

    const [onLanguage, setOnLanguage] = useState("");  
    const { brand } = useContext(RedirectUrlValue);
    const [onData, setOnData] = useState("");
    const { language } = useContext(LanguageValue);

    const fetchData = useCallback (async () => {
        try {
            const clientData = await getClientByClient(brand);
            setOnData(clientData);
            if ( clientData.version == "demo") {
                const languageData = await getOnLanguage(language);
                setOnLanguage(languageData);
            } else {
                const languageData = await getOnLanguage(language);
                setOnLanguage(languageData);
            }
        } catch (error) {
            console.log('Une erreur s\'est produite lors de la récupération des données.');
        }
    }, [brand, language]);

    useEffect(() => {
        fetchData();
    }, []);

    return(
        <div className="popup popupComment">
            {onLanguage ? (
                <h3>{onLanguage.popupDesactiveModule.text}</h3>
            ) : (
                <Loading/>
            )}
        </div>
    )
}